import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { getObjFromId } from '../../../utils/directusFunctions';
import SingleSelect from '../../formElements/SingleSelect';

const LocationSelect = ({
    locationId,
    serviceId,
    onLocationChange,
    isAuditable = false,
    onSearchAuditItems,
    errors = {},
    disabled = false
}) => {
    // LOCAL STATE
    const [filteredLocations, setFilteredLocations] = useState([]);
    const [currentLocation, setCurrentLocation] = useState({});

    // STORE STATE
    const locationsByServiceId = useSelector(
        (state) => state.entities.directusService.locationsByServiceId
    );

    // USE EFFECTS
    useEffect(() => {
        setFilteredLocations(
            serviceId in locationsByServiceId ? locationsByServiceId[serviceId] : []
        );
    }, [serviceId, locationsByServiceId]);

    useEffect(() => {
        const location = getObjFromId(filteredLocations, locationId);
        setCurrentLocation(location);
    }, [filteredLocations]);

    const onChange = (id) => {
        const location = getObjFromId(filteredLocations, id);
        setCurrentLocation(location);
        onLocationChange('locationId', id, location);
    };

    // RENDER
    return (
        <SingleSelect
            id="locationId"
            label="Location"
            placeholder="Select location..."
            mandatory={true}
            disabled={disabled}
            isAuditable={isAuditable}
            onSearchAuditItems={onSearchAuditItems}
            menuItems={filteredLocations || []}
            selectedId={locationId || ''}
            selected={currentLocation}
            error={errors.locationId}
            onChange={(id) => onChange(id)}
        />
    );
};

LocationSelect.propTypes = {
    locationId: PropTypes.string,
    serviceId: PropTypes.string,
    onLocationChange: PropTypes.func,
    isAuditable: PropTypes.bool,
    onSearchAuditItems: PropTypes.func,
    errors: PropTypes.object,
    disabled: PropTypes.bool
};

export default LocationSelect;
